export const PRIVACY_MASK = '••••';
export const PRIVACY_MODE_STORAGE_KEY = 'subpilot_privacy_mode';

export function maskChannelName(name: string): string {
  const normalized = name.trim();
  if (!normalized) return PRIVACY_MASK;
  return `${PRIVACY_MASK}${Array.from(normalized).slice(-4).join('')}`;
}

export function readStoredPrivacyMode(): boolean {
  try {
    return window.localStorage.getItem(PRIVACY_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeStoredPrivacyMode(enabled: boolean): void {
  try {
    window.localStorage.setItem(PRIVACY_MODE_STORAGE_KEY, String(enabled));
  } catch {
    // Local storage may be unavailable in restricted browser contexts.
  }
}
